import { BorerActivityDocument } from '../BorerActivity/queryBuilder';
import { EmployeeDocument } from '../Employees/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, push, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import {
  BorerShiftActivityEmployeeDocument,
  borerShiftActivityEmployeePullQueryBuilder,
  borerShiftActivityEmployeePushQueryBuilder,
} from './queryBuilder';

export function borerShiftActivityEmployeesFamilyMember(
  configBuilder: ConfigBuilder,
  borerActivity: FamilyMember<BorerActivityDocument>,
  employees: FamilyMember<EmployeeDocument>,
): FamilyMember<BorerShiftActivityEmployeeDocument> {
  const syncConfig = configBuilder<BorerShiftActivityEmployeeDocument>(
    RxdbCollectionNameV2.BORER_SHIFT_ACTIVITY_EMPLOYEES,
  );
  doNotAutoSync(syncConfig);

  pull(syncConfig, borerShiftActivityEmployeePullQueryBuilder);
  push(syncConfig, borerShiftActivityEmployeePushQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.BORER_SHIFT_ACTIVITY_EMPLOYEES, replicationState, [
    borerActivity,
    employees,
  ]);
}
